
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iM8uF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4540387e2c10982e$export$2e2bcd8739ae039; });

var $5FWfv = parcelRequire("5FWfv");

var $4PX7H = parcelRequire("4PX7H");

var $bkpwq = parcelRequire("bkpwq");

var $czKof = parcelRequire("czKof");

var $5R1xE = parcelRequire("5R1xE");

var $4EZzB = parcelRequire("4EZzB");

var $4jHtl = parcelRequire("4jHtl");

var $dcfxy = parcelRequire("dcfxy");

var $7Y5GD = parcelRequire("7Y5GD");

var $jNs1Y = parcelRequire("jNs1Y");

var $iycwB = parcelRequire("iycwB");

var $awuCn = parcelRequire("awuCn");

var $he8pH = parcelRequire("he8pH");

const $4540387e2c10982e$var$BasePage = /*#__PURE__*/ (0, $4PX7H.lazy)(()=>Promise.resolve((parcelRequire("bLGg2"))));
const $4540387e2c10982e$var$LoginPage = ()=>{
    (0, $czKof.useLoginPageViewed)();
    const shouldOrchestrate = (0, $7Y5GD.useShouldOrchestrate)();
    const loginError = (0, $bkpwq.useAppSelector)((state)=>state.login?.error);
    const { errorCode: errorCode } = (0, $iycwB.useSearchParamCodes)();
    const error = loginError || errorCode;
    const recaptchaType = error?.code === 'captchaScoreTooLow' ? 'checkbox' : 'score';
    return /*#__PURE__*/ (0, $5FWfv.jsx)((0, $5R1xE.LoginTooManyAttemptsRecaptchaContextProvider), {
        children: /*#__PURE__*/ (0, $5FWfv.jsx)((0, $4EZzB.LoginRecoveryOptionsContextProvider), {
            children: /*#__PURE__*/ (0, $5FWfv.jsx)((0, $4jHtl.LoginGoogleOneTapRenderBoundary), {
                children: /*#__PURE__*/ (0, $5FWfv.jsx)((0, $dcfxy.MarketingConsentContextProvider), {
                    children: /*#__PURE__*/ (0, $5FWfv.jsx)((0, $awuCn.RecaptchaContextProvider), {
                        pageId: (0, $he8pH.loginPageId),
                        action: "checkUsername",
                        type: recaptchaType,
                        children: shouldOrchestrate ? /*#__PURE__*/ (0, $5FWfv.jsx)((0, $jNs1Y.default), {}) : /*#__PURE__*/ (0, $5FWfv.jsx)($4540387e2c10982e$var$BasePage, {})
                    })
                })
            })
        })
    });
};
var $4540387e2c10982e$export$2e2bcd8739ae039 = $4540387e2c10982e$var$LoginPage;

});
parcelRegister("czKof", function(module, exports) {

$parcel$export(module.exports, "useLoginPageViewed", function () { return $8ae5691d64b87533$export$6d3326ed5d8fb40e; });

var $3GlkY = parcelRequire("3GlkY");

var $cMV0W = parcelRequire("cMV0W");

var $he8pH = parcelRequire("he8pH");

var $iycwB = parcelRequire("iycwB");
const $8ae5691d64b87533$export$6d3326ed5d8fb40e = ()=>{
    const location = (0, $3GlkY.useLocation)();
    const queryParams = new URLSearchParams(location.search);
    const appendReasonViewingScreen = (0, $iycwB.useAppendReasonViewingScreen)();
    (0, $cMV0W.usePageViewedEvent)((0, $he8pH.loginPageId), {
        ...(0, $cMV0W.appendReferer)(appendReasonViewingScreen({})),
        noAccess: !!queryParams.get('tenant')
    });
    (0, $cMV0W.useOperationalEvent)({
        page: (0, $he8pH.loginPageId),
        action: 'loadLoginPageSuccessful',
        subject: 'sli'
    });
};

});

parcelRegister("4jHtl", function(module, exports) {

$parcel$export(module.exports, "LoginGoogleOneTapRenderBoundary", function () { return $a16121264a613c25$export$bc9e03527d642019; });

var $5FWfv = parcelRequire("5FWfv");
parcelRequire("4PX7H");

var $82vzt = parcelRequire("82vzt");

var $bkpwq = parcelRequire("bkpwq");

var $he8pH = parcelRequire("he8pH");

var $4EZzB = parcelRequire("4EZzB");

var $kFg5i = parcelRequire("kFg5i");

var $lplGg = parcelRequire("lplGg");

var $k1WLV = parcelRequire("k1WLV");

var $8J4XE = parcelRequire("8J4XE");
const $a16121264a613c25$export$bc9e03527d642019 = ({ children: children })=>{
    const dynamicConfigs = (0, $lplGg.useDynamicConfigs)();
    const { loginRecoveryOptions: loginRecoveryOptions } = (0, $4EZzB.useLoginRecoveryOptionsContext)();
    const { isGoogleOneTapDismissed: isGoogleOneTapDismissed } = (0, $kFg5i.useSocialLogin)();
    const { googleAuthClientId: googleAuthClientId } = (0, $bkpwq.useAppSelector)((state)=>state.appConfig);
    const hashedCsrfToken = (0, $bkpwq.useAppSelector)((state)=>state.hashedCsrfToken);
    const disableOneTap = isGoogleOneTapDismissed || (0, $8J4XE.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $k1WLV.AidFrontendDynamicConfig).GOOGLE_ONE_TAP_KILL_SWITCH);
    return /*#__PURE__*/ (0, $5FWfv.jsx)((0, $82vzt.default), {
        csrfToken: hashedCsrfToken ?? 'token-should-be-loaded',
        googleAuthClientId: googleAuthClientId,
        source: (0, $he8pH.loginPageId),
        enabled: !disableOneTap,
        recoveryOptions: loginRecoveryOptions,
        children: children
    });
};

});

parcelRegister("jNs1Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f02c77d84f03c777$export$2e2bcd8739ae039; });

var $5FWfv = parcelRequire("5FWfv");

var $4PX7H = parcelRequire("4PX7H");

var $7Y5GD = parcelRequire("7Y5GD");

var $1O8pI = parcelRequire("1O8pI");

var $955Vm = parcelRequire("955Vm");

var $kFg5i = parcelRequire("kFg5i");

var $iycwB = parcelRequire("iycwB");

var $jITNj = parcelRequire("jITNj");

var $cCyZN = parcelRequire("cCyZN");

var $k9fsE = parcelRequire("k9fsE");

var $6oSUH = parcelRequire("6oSUH");

var $6Zz89 = parcelRequire("6Zz89");

var $LZcfg = parcelRequire("LZcfg");

const $f02c77d84f03c777$var$baseLoginPage = /*#__PURE__*/ (0, $4PX7H.lazy)(()=>Promise.resolve((parcelRequire("bLGg2"))));
const $f02c77d84f03c777$var$requiredComponents = [
    (0, $1O8pI.useLogin).name,
    (0, $955Vm.useLoginSubmission).name,
    (0, $kFg5i.useSocialLogin).name,
    (0, $iycwB.useEmailFromSearchParams).name,
    (0, $jITNj.LoginRecaptcha).name,
    (0, $cCyZN.LoginMarketingConsent).name,
    // ResetPasswordLink is not required in IC/FedRAMP environments
    // where the reset password flow is disabled.
    ...!(0, $LZcfg.isIsolatedCloud)() && !(0, $LZcfg.isFedM)() ? [
        (0, $6Zz89.ResetPasswordLink).name
    ] : []
];
const $f02c77d84f03c777$var$OrchestratedLoginPage = ()=>{
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $1O8pI.useLogin)();
    if (shouldShowRememberedAccounts) // cobranding is not currently available for this page. the base page should NOT be modified for cobranding
    return /*#__PURE__*/ (0, $5FWfv.jsx)((0, $k9fsE.default), {});
    return /*#__PURE__*/ (0, $5FWfv.jsx)((0, $7Y5GD.PageOrchestrator), {
        fallback: $f02c77d84f03c777$var$baseLoginPage,
        pages: (0, $6oSUH.pages),
        requiredComponents: $f02c77d84f03c777$var$requiredComponents
    });
};
var $f02c77d84f03c777$export$2e2bcd8739ae039 = $f02c77d84f03c777$var$OrchestratedLoginPage;

});
parcelRegister("6oSUH", function(module, exports) {

$parcel$export(module.exports, "pages", function () { return $c5ce2eaeab338459$export$da3bc2f57520e3c3; });

var $4PX7H = parcelRequire("4PX7H");

var $1JeGn = parcelRequire("1JeGn");











const $c5ce2eaeab338459$export$da3bc2f57520e3c3 = [
    {
        experience: (0, $1JeGn.AdvancedCobranding).DEMO,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("47lMD"))),
        owner: 'iignatov2@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'prod: https://pollinator.prod.atl-paas.net/checks/ae69f832-ceac-472c-9cb3-916cdc50e48f',
            'stg: https://pollinator.prod.atl-paas.net/checks/efa267f0-f1e2-456f-8ef8-c34a3c32b350',
            'ddev: https://pollinator.prod.atl-paas.net/checks/6e9db949-2d59-40dc-861b-5381070f2be7'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).PRT_DEMO,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("h53yU"))),
        owner: 'jbell2@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'KIRBY-9547: Add monitoring URLs for PRT demo'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).CONFLUENCE_ATLAS_75650,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("hDZEM"))),
        owner: 'rrai2@atlassian.com',
        slackChannel: 'help-ipg',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
            'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).JIRA_ATLAS_75650,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("hDZEM"))),
        owner: 'rrai2@atlassian.com',
        slackChannel: 'help-ipg',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/26ef3ad2-9433-4999-a2f6-fa985a8c97b6',
            'prod: https://pollinator.prod.atl-paas.net/checks/84735e69-d417-4319-ba90-edc743355d10'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).ACCOUNT_LINKING,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("knv2R"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).CHAMPION_APPLY,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("jNo1I"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).CHAMPION_CONSENT,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("5rE8H"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).ENTRY_AUTH,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("c2LmA"))),
        owner: 'vmanjunath@atlassian.com',
        slackChannel: 'help-community',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/063563c6-1bc4-4e61-be6a-07ce926eda46'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).LOOM,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("emKes"))),
        owner: 'rbaldwin@atlassian.com',
        slackChannel: 'loom-team-identity',
        monitoringUrls: [
            'stg: https://pollinator.prod.atl-paas.net/checks/6309c2e3-d103-4f67-aeee-ba4c625602ea'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).ISOLATED_CLOUD,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("5ua1l"))),
        owner: 'fharrold@atlassian.com',
        slackChannel: 'id-kirby',
        monitoringUrls: [
            'TODO: https://hello.jira.atlassian.cloud/browse/IDOASIS-101'
        ]
    },
    {
        experience: (0, $1JeGn.AdvancedCobranding).TWCG_786_PRIORITISE_SSO_ON_LOGIN_PAGE,
        Component: (0, $4PX7H.lazy)(()=>(parcelRequire("7LIID"))),
        owner: 'tdermisek@atlassian.com',
        slackChannel: 'team-puma',
        monitoringUrls: [
            'prod: https://pollinator.prod.atl-paas.net/checks/e19d7c52-69cf-4a1e-bdfa-3ac351e3d2fa'
        ]
    }
];

});
parcelRegister("47lMD", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("22Hpy").then(()=>parcelRequire('i4dWh'));

});

parcelRegister("h53yU", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("auLX8").then(()=>parcelRequire('4fFeg'));

});

parcelRegister("hDZEM", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = Promise.all([
    $c1een("fv4Ec"),
    $c1een("hpw5j")
]).then(()=>parcelRequire('6YhD1'));

});

parcelRegister("knv2R", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("4BLBC").then(()=>parcelRequire('evjU8'));

});

parcelRegister("jNo1I", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("6cf1q").then(()=>parcelRequire('4Bnmg'));

});

parcelRegister("5rE8H", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("2EWJp").then(()=>parcelRequire('lN0xo'));

});

parcelRegister("c2LmA", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = $c1een("jXRaY").then(()=>parcelRequire('hUzRy'));

});

parcelRegister("emKes", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = Promise.all([
    $c1een("hRtNL"),
    $c1een("fv4Ec"),
    $c1een("2LXDe")
]).then(()=>parcelRequire('jP1SK'));

});

parcelRegister("5ua1l", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = Promise.all([
    $c1een("9e3Kt"),
    $c1een("bylyW")
]).then(()=>parcelRequire('a9A8g'));

});

parcelRegister("7LIID", function(module, exports) {

var $c1een = parcelRequire("c1een");
module.exports = Promise.all([
    $c1een("dp7Cb"),
    $c1een("8VsTi"),
    $c1een("4rgy7"),
    $c1een("8JPsq")
]).then(()=>parcelRequire('6Oj5g'));

});





//# sourceMappingURL=page.9051f38a.js.map
